<template>
  <div class="container-fluid">
    <div class="row p-0">
      <div class="col-md-12 p-0">
        <div class="col-md-12 col-sm-12 company-detail-image d-flex align-items-center justify-content-center">
          <nav class="navbar navbar-expand-lg navbar-light fixed-top myfixed_nav">
                <span class="navbar-brand">
                  <router-link to="/global/signin">
                    <img class="img-responsive logo" src="../../assets/imgs/logo-white.png"/>
                  </router-link>
                </span>
            <button class="navbar-toggler navbar-toggler-blue" type="button" data-toggle="collapse"
                    data-target="#navbarSupported" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon navbar-toggler-icon-blue"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupported">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item ">
                  <button class="btn whitebtn clickcbtn">
                                  <span class="cstitle mplus2p-m spacing1-3">
                                  <span class="cplus"></span>contact</span>
                  </button>
                </li>
              </ul>
              <img id="" @click="clickedBtn()" src="../../assets/imgs/btn-select-language-white.png"/>
              <div id="language" class="dropdown-content">
                <a class="dropitem" @click="clickedLan('en')" id="en">En</a>
                <a class="dropitem" @click="clickedLan('jp')" id="jp">Jp</a>
              </div>
            </div>
          </nav>
          <div class="Excellent-Engneer-Ec">
            <span class="text-style-1">E</span>xcellent
            <span class="text-style-1">E</span>ngineer
            <span class="text-style-1">E</span>cosystem
            <div class="layer text-style-2">優れたエンジニアを生み出すため􏰀エコシステム</div>
            <button class="btn bluebtn  spacing0-5 mplus2p-m">Contact</button>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 d-flex align-items-center justify-content-center">
          <div class="Company-Info ">Company Info

            <hr class="border color">
          </div>
        </div>
        <div class="container">
          <div class="row" style="margin-top: 40px;">
            <div class="col-md-2"></div>
            <div class="col-md-8">

              <div class="row eachinquryline">
                <div class="col-md-4">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_name')}}</p>
                </div>

                <div class="col-md-8">
                  <p class="mplus2p-m spacing1-2 noiseblack">fsfsfs</p>
                </div>
              </div>
              <div class="row eachinquryline">
                <div class="col-md-4">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_name')}}</p>
                </div>

                <div class="col-md-8">
                  <p class="mplus2p-m spacing1-2 noiseblack">fsfsfs</p>
                </div>
              </div>
              <div class="row eachinquryline">
                <div class="col-md-4">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_representative')}}</p>
                </div>

                <div class="col-md-8">
                  <p class="mplus2p-m spacing1-2 noiseblack">c_representative</p>
                </div>
              </div>
              <div class="row eachinquryline">
                <div class="col-md-4">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_location')}}</p>
                </div>

                <div class="col-md-8">
                  <p class="mplus2p-m spacing1-2 noiseblack">cp_location</p>
                </div>
              </div>

              <div class="row eachinquryline">
                <div class="col-md-4">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_company_desc')}}</p>
                </div>
                <div class="col-md-8 form-group">
                  <p class="mplus2p-m spacing1-2 noiseblack">
                    mainclient
                  </p>

                </div>
              </div>

            </div>
            <div class="col-md-2 col-sm-2 "></div>
          </div>
        </div>

        <div class="col-md-12 col-sm-12 bg2 d-flex align-items-center justify-content-center">
          <div class="Message">Message
            <hr class="border2 color">
            <img class="img-fluid illust_company_section_about_image" width="100%"
                 src="../../assets/imgs/illust-company-section-about.png" alt="">
            <p class="ITIT">IT業界ならびにITエンジニア􏰀重要性や市場認知度􏰁、こ􏰀10年で大きく変わったと感じています。
              企業に属していないとシステムを作れない時代􏰁終わり、中学生でも世􏰀中で使われるようなシステムを発信できる時代になりました。
              ITと􏰁程遠かった業界も、今やIT無しで􏰁スケールアップ􏰁難しく、そ􏰀ために􏰁優れたITエンジニアが必要になっています。ただし、現在􏰀ような人材不足な市況でなくとも、優れたエンジニアを1つ􏰀企業で雇用し続けること􏰁難しくなっており、
              企業にも柔軟性が求められています。</p>

            <p class="ITIT">私が、数多く􏰀企業で数多く􏰀エンジニアが活躍するところを見てきて感じたこと􏰁、 「優れたエンジニア􏰁、働き方􏰀形態がどうであろうと良い働きをする」
              ということです。正社員以上に長く、正社員以上に責任感があり、正社員以上に活躍しているフリーランスもいますし、
              正社員という働き方が企業とエンジニア􏰀双方にとって一番成果が出せる形態であれ􏰂それで良いかと思います。E3は􏰁、働き方フリーなエンジニアと柔軟性をもった企業が繋がり、双方によって最高􏰀出会いになるよう支援して行きます。</p>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 bg3 d-flex align-items-center justify-content-center">
          <div class="Mission">Mission
            <hr class="border3 color">
            <img class="img-fluid image" src="../../assets/imgs/illust-enginner-section-vision.png" alt="">
            <p class="layer2">これから􏰀社会を創造していく􏰀􏰁、<span class="text-style-2">"Excellent Engneer"</span> だと考えており、 そんな
              <span class="text-style-2">"Excellent Engneer"</span> が働き方(正社員やフリーランスなど)にとらわれず、
              自分􏰀価値観􏰀もとに自由に企業と結びつくことができ、 自分が必要と思うも􏰀に対してだけ対価を支払うという仕組みを作りたいと思っています。 そして、それを実現する "Platform"
              を中心として、
              <span class="text-style-2">"Excellent Engineer"</span> が生まれ、育ち、繋がり、生み出すという<span class="text-style-2">"Ecosystem" </span>
              を構築することをミッションとしています。</p>

          </div>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
  export default {
    data() {
      return {};
    },

    created() {
    },
    methods: {
      clickedBtn() {
        if ($(".dropdown-content").hasClass("show"))
          $(".dropdown-content").removeClass("show");
        else $("#language").addClass("show");
      },
      clickedLan(event) {
        $(".dropdown-content").removeClass("show");

        $(".dropitem").removeClass("ddactive");
        $("#language").addClass("ddactive");
        localStorage.setItem("lan", tid);
        this.$i18n.locale = localStorage.getItem("lan");
      }
    }
  };
</script>

<style scoped>
  .whitebtn {
    margin-bottom: 10px;
  }

  .Mission {
    font-family: CocoGothic;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 4px;
    text-align: center;
    color: #283c50;
  }

  .bg3 {
    width: 100%;
    margin-top: 30px;
    background-color: #ffffff;
  }

  .border3 {
    width: 24px;
    height: 2px;
    border-radius: 2px;
    background-color: #3d7dd8;
  }

  .layer2 {
    font-family: mplus-2p;
    font-size: 16px;
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.5;
    letter-spacing: 1.2px;
    text-align: center;
    color: #283c50;
  }

  .layer2 .text-style-1 {
    font-family: AppleSymbols;
    font-weight: normal;
  }

  .layer2 .text-style-2 {
    font-size: 20px;
    line-height: 2;
    color: #3d7dd8;
  }

  .ITIT {
    margin-top: 30px;
    font-family: mplus-2p;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.5;
    letter-spacing: 1.2px;
    text-align: center;
    color: #ffffff;
  }

  .border {
    width: 24px;
    height: 2px;
    border-radius: 2px;
    background-color: #3d7dd8;
  }

  .border2 {
    width: 24px;
    height: 2px;
    border-radius: 2px;
    background-color: #ffffff;
  }

  .bg1 {
    width: 100%;
    margin-top: 30px;
    background-color: #ffffff;
  }

  .bg2 {
    width: 100%;
    background-color: #3d7dd8;
  }

  .message-img {
    display: block;
  }

  .Message {
    display: block;
    margin-top: 30px;
    opacity: 0.8;
    font-family: CocoGothic;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 2px;
    text-align: center;
    color: #ffffff;
  }

  .Company-Info {
    width: 960px;
    margin-top: 61px;
    font-family: CocoGothic;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 2px;
    text-align: center;
    color: #b4bec8;
  }

  .layer {
    height: 19px;
    font-family: mplus-2p;
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 4px;
    color: #ffffff;
    text-shadow: 2px 2px 8px rgba(40, 60, 80, 0.24),
    -2px -2px 8px rgba(40, 60, 80, 0.24);
  }

  .layer .text-style-2 {
    font-family: AppleSymbols;
    font-weight: normal;
    color: #ffffff;
  }

  .Path {
    width: 100px;
    height: 32px;
    border-radius: 6.4px;
    background-color: #ffffff;
  }

  .Contact {
    width: 100px;
    height: 17px;
    font-family: mplus-2p;
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.2px;
    text-align: center;
    color: #3d7dd8;
  }

  .navbar-nav > li {
    margin-top: 10px;
    padding-left: 30px;
    padding-right: 30px;
  }

  .myfixed_nav {
    background-color: transparent;
    box-shadow: none;
  }

  .company-detail-image {
    width: 100%;
    height: 1000px;
    opacity: 10;
    background-repeat: no-repeat;
    /* background-size: cover; */
    text-align: center;
    background-image: url("../../assets/imgs/bg-mainvisual@2x.png") !important;
  }

  .Excellent-Engneer-Ec {
    width: 985px;
    height: 87px;
    font-family: CocoGothic;
    font-size: 64px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 3.2px;
    text-align: center;
    color: #ffffff;
    text-shadow: 2px 2px 8px rgba(40, 60, 80, 0.24),
    -2px -2px 8px rgba(40, 60, 80, 0.24);
  }

  .Excellent-Engneer-Ec .text-style-1 {
    color: #86ffee;
  }

  @media only screen and (min-width: 960px) {
    .illust_company_section_about_image {
      width: 960px !important;
    }

    .ITIT {
      width: 960px !important;
    }

    .layer2 {
      width: 960px !important;
    }

    .inquryimg {
      margin-top: 0px;
    }

    .company-detail-image {
      width: 100%;
      height: 1000px;
      opacity: 10;
      background-repeat: no-repeat;
      /* background-size: cover; */
      text-align: center;
      background-image: url("../../assets/imgs/bg-mainvisual@2x.png") !important;
    }
  }

  @media screen and (max-width: 575.98px) {
  }
</style>
